// extracted by mini-css-extract-plugin
export default {"root":"EditLoanProgramDetailsDialog_root__AixTy"};